import {
  DISPLAY_LOADER,
  DISABLED_LOADER,
  CHECKING_DATA,
} from "../types/loader.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  loader: false,
  checkingData: false,
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case DISPLAY_LOADER:
      newState.loader = true;
      return newState;
    case DISABLED_LOADER:
      newState.loader = false;
      return newState;
    case CHECKING_DATA:
      newState.checkingData = true;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
